import { render, staticRenderFns } from "./MentalDrawingForm.vue?vue&type=template&id=4b788617&scoped=true&lang=pug&"
import script from "./MentalDrawingForm.vue?vue&type=script&lang=js&"
export * from "./MentalDrawingForm.vue?vue&type=script&lang=js&"
import style0 from "./MentalDrawingForm.vue?vue&type=style&index=0&id=4b788617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b788617",
  null
  
)

export default component.exports